import React from "react";
import ReactDOM from "react-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Modal from "react-modal"; // Import react-modal

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorPage from "./shared/error-page/ErrorPage";
import InspectionViewer from "./pages/inpection-form-viewer/inspetion-form-viewer";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import * as Sentry from "@sentry/react";

import "semantic-ui-css/semantic.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import Assessment from "./pages/assessment/assessment";
import LandingLayout from "./landing-pages/LandingLayout/LandingLayout";
import AssessmentStatus from "./pages/assessment-status/assessment-status";
import WelcomePage from "./pages/Welcome/Welcome";

let externalScripts = [
  "https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js",
  "https://cdn1.stamped.io/files/widget.min.js"
];
externalScripts.forEach((e, idx) => {
  var script = document.createElement("script");
  script.src = e;
  script.type = "text/javascript";
  document.body.appendChild(script);
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />
  },
  {
    path: "*",
    element: <ErrorPage></ErrorPage>
  },
  {
    path: "inspection",
    element: <InspectionViewer />
  },
  {
    path: ":id",
    element: <LandingLayout />,
    children: [
      { path: "welcome", element: <WelcomePage /> },
      { path: "assessment", element: <Assessment /> },
      {
        path: "assessment-status",
        element: <AssessmentStatus />,
      }
    ],
  },
]);

process.env.REACT_APP_PRODUCTION === "production" &&
  Sentry.init({
    dsn: "https://4246275d4c849aeed6c209e429154f4c@o4506223868116992.ingest.sentry.io/4506223870083072",
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

// Make sure to set your app element for accessibility
Modal.setAppElement("#root");

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider>
      <RouterProvider router={router} />

      <ToastContainer />
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
